import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { useLocation } from "react-router-dom";
import Avatar from '@material-ui/core/Avatar';
import Divider from '@material-ui/core/Divider';
import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';
import Header from '../Element/Header'

function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {'Copyright © '} {new Date().getFullYear()} {' '}
            <Link color="inherit" href="https://www.jababeka.com/" target="_blank">
                Kawasan Industri Jababeka
        </Link>
            {'.'}
        </Typography>
    );
}

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(4),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(25)
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    large: {
        width: theme.spacing(10),
        height: theme.spacing(10),
    },
    divider: {
        marginBottom: theme.spacing(10)
    },
    paragraf: {
        textAlign: "justify",
        lineHeight: 2
    }
}));

export default function AccessDenied() {
    const classes = useStyles();
    const location = useLocation();

    return (
        <Container component="main" maxWidth="sm">
            <CssBaseline />
            <div className={classes.paper}>
                <Header />
                <Grid container>
                    <Grid item xs>
                        <Typography variant="body1" gutterBottom>
                            Hai, Selamat Datang di Virtual Job Fair & Scholarship Hunt 2021
                        </Typography>
                    </Grid>
                    <Typography color="textPrimary" variant="body2" className={classes.paragraf} gutterBottom>
                        Kami mohon maaf halaman ini belum bisa diakses sekarang. Kami akan informasikan apabila halaman ini sudah tersedia ya
                    </Typography>
                    <Typography color="textPrimary" variant="body2" className={classes.paragraf} gutterBottom>
                        Silahkan follow official social media kami di instagram @jababekalearningcenter atau hubungi Customer Service kami via Whatsapp 0811-8444-595 untuk mengetahui informasi dan update terbaru untuk event <b>Virtual Job Fair & Scholarship Hunt 2021</b> by <b>Kawasan Industri Jababeka.</b>
                    </Typography>
                </Grid>
            </div>
            <Box mt={10} mb={5}>
                <Copyright />
            </Box>
        </Container>
    );
}